import React from 'react';
import { useSelector } from 'react-redux';
import { selectIsOutsideSweden } from 'tradera-state/member/selectors';
import PaypalLogo from '@tradera/blueprint/theme/logos/paypal.svg?jsx';
import MastercardLogo from '@tradera/blueprint/theme/logos/mastercard_vertical.svg?jsx';
import VisaLogo from '@tradera/blueprint/theme/logos/visa.svg?jsx';
import GooglePayLogo from '@tradera/blueprint/theme/logos/google-pay.svg?jsx';
import ApplePayLogo from '@tradera/blueprint/theme/logos/apple-pay.svg?jsx';
import DhlLogo from './dhl.svg?jsx';

import SwishLogo from '@tradera/blueprint/theme/logos/swish_horizontal.svg?jsx';
import PaynovaLogo from '@tradera/blueprint/theme/logos/paynova.svg?jsx';

import styles from './footer-partners.module.scss';

export const FooterPartners = () => {
    const isOutsideSweden = useSelector(state => selectIsOutsideSweden(state));

    const partners = [
        {
            src: '/static/images/shipping/postnord.svg',
            alt: 'Postnord logo',
            height: 9,
            containerCss: styles.imageContainer
        },
        {
            src: '/static/images/shipping/schenker.svg',
            alt: 'Schenker logo',
            height: 9,
            containerCss: styles.imageContainer
        },
        {
            logo: <DhlLogo height={9} />,
            containerCss: styles.imageContainer,
            hide: isOutsideSweden
        },
        {
            src: '/static/images/shipping/bring.svg',
            alt: 'Bring logo',
            height: 15,
            containerCss: styles.imageContainer,
            hide: !isOutsideSweden
        },
        {
            logo: <VisaLogo height={10} />,
            containerCss: styles.imageContainer
        },
        {
            logo: <MastercardLogo height={15} />,
            containerCss: styles.imageContainer
        },
        {
            logo: <SwishLogo height={15} />,
            hide: isOutsideSweden,
            containerCss: styles.imageContainer
        },
        {
            logo: <PaypalLogo height={12} />,
            containerCss: styles.imageContainer
        },
        {
            logo: <PaynovaLogo height={13} />,
            hide: isOutsideSweden,
            containerCss: styles.imageContainer
        },
        {
            logo: <GooglePayLogo height={21} className="align-top" />
        },
        {
            logo: <ApplePayLogo height={21} className="align-top" />
        }
    ];

    return (
        <>
            {partners.map((partner, index) => {
                return !partner.hide ? (
                    <span
                        key={`partner_logo_${index}`}
                        className={`${
                            partner.containerCss
                                ? `${partner.containerCss} mr-1 pl-1 pr-1`
                                : 'pr-1'
                        } pn-1 mb-2`}>
                        {partner.logo ? (
                            partner.logo
                        ) : (
                            <img
                                src={partner.src}
                                alt={partner.alt}
                                height={partner.height}
                            />
                        )}
                    </span>
                ) : null;
            })}
        </>
    );
};
